import React, { Component } from "react";

//Import CSS
import "../financeiro.css";

//Import internal components
import AppContext from "../../appContext";
import TrackingSearchButton from "../financeiro-inputs/tracking-search-button";
import TrackingTableHead from "../financeiro-table/tracking-table-head";
import EmptyState from "../../shared/components/generic/empty-state/empty-state";
import { Search } from "react-bootstrap-icons";
import CnpjUtils from "../../shared/utils/CnpjUtils";

//Import external components
import { Redirect } from "react-router-dom";
import Moment from "moment";
import Swal from "sweetalert2";
import { redirectPage } from "../../components/utils/redirectpage";
import { Relacionamento } from "../../Functions/gestao-laboratorios/relacionamento";
import { TextField, Collapse, Typography } from "@material-ui/core";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//Import images

class BuscaStatus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pedido_laboratorio: "",
      pedido_otica: "",
      table: [],
      dia_inicio: new Date().setDate(new Date().getDate() - 30),
      dia_fim: new Date(),
      data_inicio: Moment(new Date().setDate(new Date().getDate() - 30)).format("YYYY-MM-DD"),
      data_fim: Moment(new Date()).format("YYYY-MM-DD"),
      resposta_tabela: false,
      loading: false,

      redeOticaAux: this.props.redeOticaAux,
      status: "PENDENTE",
      statusMessage: 'O resultado da busca com status "Em aberto" contempla as parcelas pendentes de pagamento, incluindo as já vencidas.',
      filtro_numero_documento: "",
      filtro_vencimento_dia_inicio: null,
      filtro_vencimento_dia_fim: null,
      filtro_vencimento_data_inicio: "",
      filtro_vencimento_data_fim: "",
      filtro_valor_minimo: "",
      filtro_valor_maximo: "",
      filtro_nota_fiscal: "",
      filtro_serie_nota_fiscal: "",
    };

    if (sessionStorage.getItem("token") !== null) {
      BuscaStatus.contextType = AppContext;
      this.handleChange_data_inicio = this.handleChange_data_inicio.bind(this);
      this.handleChange_data_fim = this.handleChange_data_fim.bind(this);
      this.changeState = this.changeState.bind(this);
      this.integraPedido = this.integraPedido.bind(this);
      this.validarCampos = this.validarCampos.bind(this);
    }
  }

  borderColor(idElement, color = "#f70017") {
    //#f70017  #B5B5B5
    if (typeof idElement === "object") {
      idElement.map(el => {
        if (document.getElementById(el)) {
          return (document.getElementById(el).style.boxShadow = `0 0 0 1px ${color}`);
        }
        return null;
      });
    } else {
      document.getElementById(idElement).style.boxShadow = `0 0 0 1px ${color}`;
    }
  }

  handleChange_data_inicio = date => {
    //trata o formato da data
    const diaInicio = date ? Moment(date).format("YYYY-MM-DD") : "";
    this.setState({
      //seta data para integração
      data_inicio: diaInicio,
      //seta data para exibir no input date
      dia_inicio: date,
    });
  };

  handleChange_data_fim = date => {
    //trata o formato da data
    const diaFim = date ? Moment(date).format("YYYY-MM-DD") : "";
    this.setState({
      //seta data para integração
      data_fim: diaFim,
      //seta data para exibir no input date
      dia_fim: date,
    });
  };

  handleChangeFiltroVencimentoInicio = date => {
    const dia = date ? Moment(date).format("YYYY-MM-DD") : "";
    this.setState({
      filtro_vencimento_data_inicio: dia,
      filtro_vencimento_dia_inicio: date,
    });
  };

  handleChangeFiltroVencimentoFim = date => {
    const dia = date ? Moment(date).format("YYYY-MM-DD") : "";
    this.setState({
      filtro_vencimento_data_fim: dia,
      filtro_vencimento_dia_fim: date,
    });
  };

  handleChangeFiltro = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  formatCurrencyDisplay = value => {
    if (!value) return "";
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  handleCurrencyChange = name => e => {
    let raw = e.target.value.replace(/[^0-9]/g, "");
    if (raw === "") {
      this.setState({ [name]: "" });
      return;
    }
    const decimal = (parseInt(raw, 10) / 100).toFixed(2);
    this.setState({ [name]: decimal });
  };

  getValorError = () => {
    const min = this.state.filtro_valor_minimo;
    const max = this.state.filtro_valor_maximo;
    if (min && max && parseFloat(min) > parseFloat(max)) {
      return { min: "Valor mínimo maior que o máximo", max: "Valor máximo menor que o mínimo" };
    }
    if (min && !max) return { min: "", max: "Preencha o valor máximo" };
    if (!min && max) return { min: "Preencha o valor mínimo", max: "" };
    return { min: "", max: "" };
  };

  getDataVencimentoError = () => {
    const ini = this.state.filtro_vencimento_data_inicio;
    const fim = this.state.filtro_vencimento_data_fim;
    if (ini && fim && ini > fim) {
      return { ini: "Data inicial maior que a final", fim: "Data final menor que a inicial" };
    }
    if (ini && !fim) return { ini: "", fim: "Preencha a data final" };
    if (!ini && fim) return { ini: "Preencha a data inicial", fim: "" };
    return { ini: "", fim: "" };
  };

  changeState() {
    this.setState({
      loading: true,
      data_tabela: [],
      resposta_tabela: false,
    });

    let valido = this.validarCampos();
    if (valido) {
      this.context.showLoading("Buscando...");
      this.integraPedido();
    }
  }

  validarCampos() {
    this.props.handleChangeProps("labError", null, "");
    if (!this.props.laboratorio_dados?.laboratorio_nome) {
      this.setState({ loading: false });
      this.props.handleChangeProps("labError", null, "Selecione um laboratório");
      this.context.hideLoading();
      return;
    } else if (this.context.userSession.redeOticas && this.props.redeOticaAux && !this.props.cnpj_number) {
      this.setState({
        loading: false,
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Selecione uma ótica.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor("cnpj_number");
      return;
    } else if (this.props.input_cnpj && this.props.redeOticaAux && !this.props.cnpj_number && !this.context.userSession.redeOticas) {
      this.setState({
        loading: false,
      });
      this.context.hideLoading();
      Swal.fire({
        text: "O campo CNPJ é obrigatório.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor("cnpj_number");
      return;
    } else if (this.state.status != "PENDENTE" && this.state.status != "BAIXADO" && this.state.status != "AVENCER") {
      this.setState({
        loading: false,
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Preencha o status da Parcela.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor("status");
      return;
    }

    if (this.state.data_inicio === "" || this.state.data_fim === "") {
      this.setState({
        loading: false,
      });
      this.context.hideLoading();
      Swal.fire({
        text: " Por favor, informe um período válido para o seu pedido.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor(["data_inicio", "data_fim"]);
      return;
    } else if (this.state.data_inicio > this.state.data_fim) {
      this.setState({
        loading: false,
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Período da busca inválido: Data inicial maior que data final.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor(["data_inicio", "data_fim"]);
      return;
    } else {
      let ini = new Date(this.state.data_inicio);
      let fim = new Date(this.state.data_fim);
      let diff = (fim.getTime() - ini.getTime()) / 1000 / 3600 / 24;
      if (diff > 60) {
        this.setState({
          loading: false,
        });
        this.context.hideLoading();
        Swal.fire({
          text: "O período de busca não pode ser superior a 60 dias.",
          title: "Aviso",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        });
        this.borderColor(["data_inicio", "data_fim"]);
        return;
      }
    }

    if (this.props.novosFiltrosFinanceiros) {
      const vencIni = this.state.filtro_vencimento_data_inicio;
      const vencFim = this.state.filtro_vencimento_data_fim;
      if ((vencIni && !vencFim) || (!vencIni && vencFim)) {
        this.setState({ loading: false });
        this.context.hideLoading();
        Swal.fire({ text: "Preencha ambas as datas de vencimento.", title: "Aviso", icon: "warning", confirmButtonColor: "#3085d6", confirmButtonText: "Ok" });
        return;
      }
      if (vencIni && vencFim && vencIni > vencFim) {
        this.setState({ loading: false });
        this.context.hideLoading();
        Swal.fire({ text: "Data de vencimento inicial maior que a final.", title: "Aviso", icon: "warning", confirmButtonColor: "#3085d6", confirmButtonText: "Ok" });
        return;
      }

      const valMin = this.state.filtro_valor_minimo;
      const valMax = this.state.filtro_valor_maximo;
      if ((valMin && !valMax) || (!valMin && valMax)) {
        this.setState({ loading: false });
        this.context.hideLoading();
        Swal.fire({ text: "Preencha ambos os campos de valor (mínimo e máximo).", title: "Aviso", icon: "warning", confirmButtonColor: "#3085d6", confirmButtonText: "Ok" });
        return;
      }
      if (valMin && valMax && parseFloat(valMin) > parseFloat(valMax)) {
        this.setState({ loading: false });
        this.context.hideLoading();
        Swal.fire({ text: "Valor mínimo maior que o valor máximo.", title: "Aviso", icon: "warning", confirmButtonColor: "#3085d6", confirmButtonText: "Ok" });
        return;
      }

      const nf = this.state.filtro_nota_fiscal;
      const serie = this.state.filtro_serie_nota_fiscal;
      if ((nf && !serie) || (!nf && serie)) {
        this.setState({ loading: false });
        this.context.hideLoading();
        Swal.fire({ text: "Preencha ambos os campos de Nota Fiscal (número e série).", title: "Aviso", icon: "warning", confirmButtonColor: "#3085d6", confirmButtonText: "Ok" });
        return;
      }
    }

    return true;
  }

  async integraPedido() {
    if (this.context.userSession.papelCategoria === "LABORATORIO") {
      const oticaCnpj = CnpjUtils.cleanCnpj(this.props.cnpj_number);
      const labCnpj = this.props.laboratorio_dados.laboratorio_cnpj;
      const relacionamento = await Relacionamento(labCnpj, oticaCnpj);
      if (relacionamento === false) {
        this.context.hideLoading();
        this.setState({ loading: false });
        Swal.fire({
          text: "A ótica informada não possui relacionamento com o laboratório.",
          title: "Aviso",
          icon: "warning",
          confirmButtonColor: "#00518b",
          confirmButtonText: "Ok",
        });
        return;
      }
    }

    var status = this.state.status !== "AVENCER" ? this.state.status : "PENDENTE";
    var table = [];
    const requestOptions = {
      method: "GET",
      headers: {
        access_token: sessionStorage.getItem("token"),
        client_id: localStorage.getItem("clientid"),
        laboratorio: this.props.laboratorio_dados.laboratorio_cnpj,
        otica: CnpjUtils.cleanCnpj(this.props.cnpj_number),
      },
    };

    let filterParams = "";
    if (this.props.novosFiltrosFinanceiros) {
      const filters = {
        numeroDocumento: this.state.filtro_numero_documento,
        dataVencimentoInicial: this.state.filtro_vencimento_data_inicio,
        dataVencimentoFinal: this.state.filtro_vencimento_data_fim,
        valorFaturaInicial: this.state.filtro_valor_minimo,
        valorFaturaFinal: this.state.filtro_valor_maximo,
        numeroNotaFiscal: this.state.filtro_nota_fiscal,
        serieNotaFiscal: this.state.filtro_serie_nota_fiscal,
      };
      Object.keys(filters).forEach(key => { if (!filters[key]) delete filters[key]; });
      const extra = Object.entries(filters).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
      if (extra) filterParams = "&" + extra;
    }

    fetch(process.env.REACT_APP_ESSILOR_API + `gestao-financeira-cliente-laboratorio/v1/faturas?status=${status}${filterParams}`, requestOptions)
      .then(response => {
        return response.json();
      })
      .then(response => {
        let data = [];
        let today = new Date();
        let next15Days = new Date();
        next15Days.setDate(next15Days.getDate() + 15);

        if (this.state.status !== "AVENCER") {
          response.forEach(fatura => {
            let dataVencimento = new Date(fatura.dataVencimento);
            var statusFatura = fatura.status;
            if (dataVencimento >= today && dataVencimento <= next15Days) {
              statusFatura = "AVENCER";
            }
            data.push({
              codigo: fatura.codigo,
              parcela: fatura.parcela.substring(0, 2) + "/" + fatura.parcela.substring(2),
              nDocumento: fatura.numeroDocumento,
              dataEmissao: fatura.dataEmissao,
              dataVencimento: fatura.dataVencimento,
              valor: fatura.valor,
              valorAberto: fatura.valorAberto,
              status: statusFatura,
              statusApi: fatura.status,
            });
          });
          data.sort((a, b) => {
            if (Moment(a.dataVencimento) < Moment(b.dataVencimento)) return -1;
            if (Moment(a.dataVencimento) > Moment(b.dataVencimento)) return 1;
            return 0;
          });
        } else {
          response.forEach(fatura => {
            let dataVencimento = new Date(fatura.dataVencimento);
            var statusFatura = fatura.status;
            if (dataVencimento >= today && dataVencimento <= next15Days) {
              statusFatura = "AVENCER";
              data.push({
                codigo: fatura.codigo,
                parcela: fatura.parcela.substring(0, 2) + "/" + fatura.parcela.substring(2),
                nDocumento: fatura.numeroDocumento,
                dataEmissao: fatura.dataEmissao,
                dataVencimento: fatura.dataVencimento,
                valor: fatura.valor,
                valorAberto: fatura.valorAberto,
                status: fatura.status,
                statusApi: fatura.status,
              });
            }
            table.push({
              codigo: fatura.codigo,
              parcela: fatura.parcela.substring(0, 2) + "/" + fatura.parcela.substring(2),
              nDocumento: fatura.numeroDocumento,
              dataEmissao: fatura.dataEmissao,
              dataVencimento: fatura.dataVencimento,
              valor: fatura.valor,
              valorAberto: fatura.valorAberto,
              status: statusFatura,
              statusApi: fatura.status,
            });
          });
          data.sort((a, b) => {
            if (Moment(a.dataVencimento) < Moment(b.dataVencimento)) return -1;
            if (Moment(a.dataVencimento) > Moment(b.dataVencimento)) return 1;
            return 0;
          });
        }
        this.setState({
          data_tabela: data,
          table: table,
          resposta_tabela: true,
          loading: false,
        });
        this.context.hideLoading();
      })
      .catch(() => {
        this.setState({
          data_tabela: [],
          resposta_tabela: false,
          loading: false,
        });
        this.context.hideLoading();
        //TK-083-000169 - Adicionado a mensagem abaixo em caso de falha na integração.
        Swal.fire({
          text: "Falha de comunicação com o laboratório. Tente novamente mais tarde.",
          title: "Aviso",
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        });
      });
  }

  render() {
    const { redirectL } = this.state;

    if (this.state.redirect) {
      return <Redirect to="/home" />;
    }

    if (redirectL) {
      return <Redirect to="/" />;
    }

    let itensStatus = [
      { label: "EM ABERTO", value: "PENDENTE", key: "PENDENTE" },
      { label: "PAGO", value: "BAIXADO", key: "BAIXADO" },
      { label: "AVENCER", value: "AVENCER", key: "AVENCER" },
    ];
    return (
      <>
        <div className="row d-flex justify-content-center" style={{ marginBottom: "1.5rem" }}>
          <div className="col-xs-12 col-md-11 mx-auto">
            <Typography variant="subtitle1" style={{ color: "#00518b" }} gutterBottom>
              Status da Parcela *
            </Typography>
            <ToggleButtonGroup
              value={this.state.status}
              exclusive
              onChange={(event, newValue) => {
                if (newValue !== null) {
                  this.setState({ status: newValue }, () => {
                    if (newValue === "PENDENTE") {
                      this.setState({ statusMessage: 'O resultado da busca com status "Em aberto" contempla as parcelas pendentes de pagamento, incluindo as já vencidas.' });
                    } else if (newValue === "BAIXADO") {
                      this.setState({ statusMessage: 'O resultado da busca com status "Pago" contempla as parcelas dos últimos 120 dias.' });
                    } else if (newValue === "AVENCER") {
                      this.setState({ statusMessage: 'O resultado da busca com status "A vencer" contempla as parcelas vencendo em 15 dias.' });
                    }
                  });
                }
              }}
              aria-label="status da parcela"
              className="financeiro-toggle-status"
            >
              <ToggleButton value="AVENCER" disableRipple aria-label="a vencer">A vencer</ToggleButton>
              <ToggleButton value="PENDENTE" disableRipple aria-label="em aberto">Em aberto</ToggleButton>
              <ToggleButton value="BAIXADO" disableRipple aria-label="pago">Pago</ToggleButton>
            </ToggleButtonGroup>
            {this.state.statusMessage && (
              <div className="tooltipDivFinanceiro" style={{ marginTop: "0.75rem" }}>
                <div className="tooltipFixo">
                  <spam>i</spam>
                </div>
                <p>{this.state.statusMessage}</p>
              </div>
            )}
          </div>
        </div>

        <Collapse in={this.props.novosFiltrosFinanceiros} timeout={400}>
          <div className="financeiro-novos-filtros" style={{ marginTop: "3rem" }}>

            <div className="row d-flex justify-content-center">
              <div className="col-xs-12 col-md-5">
                <TextField
                  variant="outlined"
                  className="lp-field"
                  label="Número do documento"
                  name="filtro_numero_documento"
                  value={this.state.filtro_numero_documento}
                  onChange={this.handleChangeFiltro}
                  autoComplete="off"
                />
              </div>
              <div className="col-xs-6 col-md-3">
                <DatePicker
                  selected={this.state.filtro_vencimento_dia_inicio}
                  onChange={this.handleChangeFiltroVencimentoInicio}
                  dateFormat="dd/MM/yyyy"
                  locale="pt"
                  autoComplete="off"
                  customInput={
                    <TextField variant="outlined" className="lp-field" label="Data de vencimento inicial"
                      error={!!this.getDataVencimentoError().ini}
                      helperText={this.getDataVencimentoError().ini} />
                  }
                />
              </div>
              <div className="col-xs-6 col-md-3">
                <DatePicker
                  selected={this.state.filtro_vencimento_dia_fim}
                  onChange={this.handleChangeFiltroVencimentoFim}
                  dateFormat="dd/MM/yyyy"
                  locale="pt"
                  autoComplete="off"
                  customInput={
                    <TextField variant="outlined" className="lp-field" label="Data de vencimento final"
                      error={!!this.getDataVencimentoError().fim}
                      helperText={this.getDataVencimentoError().fim} />
                  }
                />
              </div>
            </div>

            <div className="row d-flex justify-content-center">
              <div className="col-xs-6 col-md-3">
                <TextField
                  variant="outlined"
                  className="lp-field"
                  label="Valor mínimo"
                  name="filtro_valor_minimo"
                  value={this.formatCurrencyDisplay(this.state.filtro_valor_minimo)}
                  onChange={this.handleCurrencyChange("filtro_valor_minimo")}
                  autoComplete="off"
                  error={!!this.getValorError().min}
                  helperText={this.getValorError().min}
                />
              </div>
              <div className="col-xs-6 col-md-3">
                <TextField
                  variant="outlined"
                  className="lp-field"
                  label="Valor máximo"
                  name="filtro_valor_maximo"
                  value={this.formatCurrencyDisplay(this.state.filtro_valor_maximo)}
                  onChange={this.handleCurrencyChange("filtro_valor_maximo")}
                  autoComplete="off"
                  error={!!this.getValorError().max}
                  helperText={this.getValorError().max}
                />
              </div>
              <div className="col-xs-6 col-md-3">
                <TextField
                  variant="outlined"
                  className="lp-field"
                  label="Nota fiscal"
                  name="filtro_nota_fiscal"
                  value={this.state.filtro_nota_fiscal}
                  onChange={this.handleChangeFiltro}
                  autoComplete="off"
                />
              </div>
              <div className="col-xs-6 col-md-2">
                <TextField
                  variant="outlined"
                  className="lp-field"
                  label="Série"
                  name="filtro_serie_nota_fiscal"
                  value={this.state.filtro_serie_nota_fiscal}
                  onChange={this.handleChangeFiltro}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
        </Collapse>

        <div className="row">
          <TrackingSearchButton onClick={this.changeState} />
        </div>

        <section ref={ref => (this.myRef = ref)} className="mt-4">
          {this.state.resposta_tabela &&
            (this.state.data_tabela.length > 0 ? (
              <TrackingTableHead
                laboratorio_nome={this.props.laboratorio_dados.laboratorio_nome}
                laboratorio_cnpj={this.props.laboratorio_dados.laboratorio_cnpj}
                detailOrder={this.props.laboratorio_dados.detailOrder}
                otica_cnpj={
                  this.props.cnpj_number ? this.props.cnpj_number.replace(".", "").replace(".", "").replace("-", "").replace("/", "") : this.props.cnpj_number
                }
                usuario_logado={this.context.userSession.conta}
                data_tabela={this.state.data_tabela}
                status={this.state.status}
                table={this.state.table}
              />
            ) : (
              <EmptyState
                icon={Search}
                title="Nenhum registro encontrado"
                description={this.props.novosFiltrosFinanceiros ? "Tente ajustar os filtros para encontrar resultados." : "Não foram encontradas parcelas para o status selecionado."}
              />
            ))}
        </section>
      </>
    );
  }
}

export default BuscaStatus;
